/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfile } from './StoreProfile';
import {
    StoreProfileFromJSON,
    StoreProfileFromJSONTyped,
    StoreProfileToJSON,
    StoreProfileToJSONTyped,
} from './StoreProfile';
import type { StoreProfileNewRequestOverview } from './StoreProfileNewRequestOverview';
import {
    StoreProfileNewRequestOverviewFromJSON,
    StoreProfileNewRequestOverviewFromJSONTyped,
    StoreProfileNewRequestOverviewToJSON,
    StoreProfileNewRequestOverviewToJSONTyped,
} from './StoreProfileNewRequestOverview';
import type { StoreProfileDraft } from './StoreProfileDraft';
import {
    StoreProfileDraftFromJSON,
    StoreProfileDraftFromJSONTyped,
    StoreProfileDraftToJSON,
    StoreProfileDraftToJSONTyped,
} from './StoreProfileDraft';

/**
 * 
 * @export
 * @interface StoreProfiles
 */
export interface StoreProfiles {
    /**
     * 
     * @type {Array<StoreProfile>}
     * @memberof StoreProfiles
     */
    profiles: Array<StoreProfile>;
    /**
     * 
     * @type {Array<StoreProfileNewRequestOverview>}
     * @memberof StoreProfiles
     */
    newRequests: Array<StoreProfileNewRequestOverview>;
    /**
     * 
     * @type {Array<StoreProfileDraft>}
     * @memberof StoreProfiles
     */
    drafts: Array<StoreProfileDraft>;
}

/**
 * Check if a given object implements the StoreProfiles interface.
 */
export function instanceOfStoreProfiles(value: object): value is StoreProfiles {
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    if (!('newRequests' in value) || value['newRequests'] === undefined) return false;
    if (!('drafts' in value) || value['drafts'] === undefined) return false;
    return true;
}

export function StoreProfilesFromJSON(json: any): StoreProfiles {
    return StoreProfilesFromJSONTyped(json, false);
}

export function StoreProfilesFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfiles {
    if (json == null) {
        return json;
    }
    return {
        
        'profiles': ((json['profiles'] as Array<any>).map(StoreProfileFromJSON)),
        'newRequests': ((json['newRequests'] as Array<any>).map(StoreProfileNewRequestOverviewFromJSON)),
        'drafts': ((json['drafts'] as Array<any>).map(StoreProfileDraftFromJSON)),
    };
}

export function StoreProfilesToJSON(json: any): StoreProfiles {
    return StoreProfilesToJSONTyped(json, false);
}

export function StoreProfilesToJSONTyped(value?: StoreProfiles | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'profiles': ((value['profiles'] as Array<any>).map(StoreProfileToJSON)),
        'newRequests': ((value['newRequests'] as Array<any>).map(StoreProfileNewRequestOverviewToJSON)),
        'drafts': ((value['drafts'] as Array<any>).map(StoreProfileDraftToJSON)),
    };
}

